import * as React from 'react';

import {Checkbox} from 'shells/checkbox/checkbox';

import {useActivityModalContext} from '../activity-modal-context';
import {setLocalStorageShouldSyncToCalendar, getCalendarServiceName} from '../helpers';

import styles from './footer.module.css';

export function ShouldSyncToCalendarCheckbox() {
    const {
        shouldSyncToCalendar,
        setShouldSyncToCalendar,
        calendarSyncExternalService,
        isUserParticipating,
    } = useActivityModalContext();

    const handleCheckboxChange = (value: boolean) => {
        setShouldSyncToCalendar(value);
        setLocalStorageShouldSyncToCalendar(value);
    };

    const serviceName = getCalendarServiceName(calendarSyncExternalService);

    const label = serviceName ? `Sync to my ${serviceName} calendar` : 'Sync to my calendar';
    const tooltip = isUserParticipating
        ? null
        : 'You must be a participant of this<br />activity to sync it to your calendar';

    return (
        <div data-multiline={true} data-tip={tooltip} className={styles['sync-checkbox']}>
            <Checkbox
                label={label}
                checked={shouldSyncToCalendar}
                onChange={handleCheckboxChange}
                disabled={!isUserParticipating}
            />
        </div>
    );
}
